import React, { useState, useEffect, useRef } from 'react';

import { CSSTransition } from 'react-transition-group';
import { truncate } from 'lodash';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import { TiChevronLeft } from 'react-icons/ti';
import TicketPurchasing from 'widget/event_components/ticket-purchasing';
import styles from '../checkout.scss';

// const scrollIntoViewIfNeeded = (target) => {
//   if (window.isMobileType) {
//     scrollIntoView(target, { behaviour: 'smooth', block: 'start', inline: 'nearest' });
//     return;
//   }
//   // Target is outside the viewport from the bottom
//   if (target.getBoundingClientRect().bottom > window.innerHeight) {
//     //  The bottom of the target will be aligned to the bottom of the visible area of the scrollable ancestor.
//     scrollIntoView(target, false);
//   }

//   // Target is outside the view from the top
//   if (target.getBoundingClientRect().top < 0) {
//     // The top of the target will be aligned to the top of the visible area of the scrollable ancestor
//     scrollIntoView(target, { behaviour: 'smooth' });
//   }
// };

export const DefaultCheckout = ({
  event,
  settings,
  openTicketing,
  onClose,
  transitionClassName = '',
  inClassName = '',
  children,
  onResizeComponent,
}) => {
  const [dynamicMinHeight, setDynamicMinHeight] = useState(250); // Start with default minHeight
  const childrenRef = useRef(null);
  const title = window.isMobileType
    ? event.get('title')
    : truncate(event.get('title'), {
        length: 20,
      });
  const [height, setHeight] = useState('100%');
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current.clientHeight === 0) {
      setHeight(ref.current.clientHeight);
    }
  }, [height]);

  useEffect(() => {
    if (childrenRef.current) {
      const currentHeight = childrenRef.current.clientHeight;
      setDynamicMinHeight(Math.max(250, currentHeight)); // Ensures minHeight is at least 250
    }
  }, [childrenRef, children]);
  const ticketSpotEnabled = event.get('use_checkout_form') && event.get('type') === 'eventviewer';
  return (
    <CSSTransition
      className={transitionClassName}
      classNames="checkout-fade"
      timeout={0}
      in={openTicketing}
      style={{ marginBottom: window.isMobileType ? 10 : 0 }}
    >
      <div
        className={`${inClassName} ${styles.checkout}`}
        style={{ position: 'relative', minHeight: dynamicMinHeight, height: '100%' }}
        ref={ref}
        id={`checkout-${event.get('id')}`}
      >
        {(ticketSpotEnabled || settings.get('embedTicketPurchasing')) && openTicketing ? (
          <div style={{ minHeight: 250, display: 'flex', flexDirection: 'column' }}>
            {onClose && (
              <span className="back" onClick={onClose}>
                <Button className={cn('attendee_button', { 'square-buttons': !settings.get('buttonRounded') })}>
                  <TiChevronLeft size={25} className="checkout-arrow" />
                  {title}
                </Button>
              </span>
            )}
            <TicketPurchasing event={event} settings={settings} open={openTicketing} onResizeComponent={onResizeComponent} />
          </div>
        ) : (
          <div ref={childrenRef}>{React.cloneElement(children)}</div>
        )}
      </div>
    </CSSTransition>
  );
};
